import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import TentangPage from './pages/TentangPage';
import LayananPage from './pages/LayananPage';
import LayananDetailPage from './pages/LayananDetailPage';
import ProdukPage from './pages/ProdukPage';
import PaketPage from './pages/PaketPage';
import StudiKasusPage from './pages/StudiKasusPage';
import IndustriPage from './pages/IndustriPage';
import IndustriDetailPage from './pages/IndustriDetailPage';
import ProsesPage from './pages/ProsesPage';
import BlogPage from './pages/BlogPage';
import FAQPage from './pages/FAQPage';
import KonsultasiPage from './pages/KonsultasiPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tentang" element={<TentangPage />} />
        <Route path="/layanan" element={<LayananPage />} />
        <Route path="/layanan/:slug" element={<LayananDetailPage />} />
        <Route path="/produk" element={<ProdukPage />} />
        <Route path="/paket" element={<PaketPage />} />
        <Route path="/studi-kasus" element={<StudiKasusPage />} />
        <Route path="/industri" element={<IndustriPage />} />
        <Route path="/industri/:slug" element={<IndustriDetailPage />} />
        <Route path="/proses" element={<ProsesPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/konsultasi" element={<KonsultasiPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
